export default __webpack_public_path__ + "static/media/BackgroundKahshStoreMobile.665a8c94.png";